import React, { useState, useContext } from 'react';
import ThemeContext from '../contexts/ThemeContext';
import './CustomColorPicker.css';

const CustomColorPicker = ({ onClose }) => {
  const { updateCustomColors } = useContext(ThemeContext);
  const [colors, setColors] = useState({
    'primary-color': '#ff6b9d',
    'secondary-color': '#c471ed',
    'bg-color': '#0a0e27',
    'surface-color': '#1a1f3a',
    'text-primary': '#ffffff',
    'text-secondary': '#b0b8d1',
    'accent-color': '#00d4ff'
  });

  const colorLabels = {
    'primary-color': '主色调',
    'secondary-color': '次色调',
    'bg-color': '背景色',
    'surface-color': '卡片背景',
    'text-primary': '主文字',
    'text-secondary': '次文字',
    'accent-color': '强调色'
  };

  const handleColorChange = (key, value) => {
    setColors({ ...colors, [key]: value });
  };

  const handleApply = () => {
    updateCustomColors(colors);
    onClose();
  };

  return (
    <div className="custom-color-picker">
      <h3>自定义颜色</h3>
      <div className="color-inputs">
        {Object.keys(colors).map(key => (
          <div key={key} className="color-input-group">
            <label>{colorLabels[key]}</label>
            <div className="color-input-wrapper">
              <input
                type="color"
                value={colors[key]}
                onChange={(e) => handleColorChange(key, e.target.value)}
              />
              <input
                type="text"
                value={colors[key]}
                onChange={(e) => handleColorChange(key, e.target.value)}
                placeholder="#000000"
              />
            </div>
          </div>
        ))}
      </div>
      <div className="color-picker-actions">
        <button onClick={handleApply} className="apply-btn">应用</button>
        <button onClick={onClose} className="cancel-btn">取消</button>
      </div>
    </div>
  );
};

export default CustomColorPicker;


